import { RouteObject } from "react-router-dom";
import VerificationPage from "./pages/VerificationPage";

export const verificationRoutes: RouteObject[] = [
  { path: "verification", element: <VerificationPage /> },
];
